<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="mat-typography" [innerHTML]="data.content">
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="!!data.okButton || !!data.noButton">
  <button mat-button mat-dialog-close *ngIf="data.noButton" color="primary">{{data.noButton}}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial color="primary">{{data.okButton}}</button>
</mat-dialog-actions>
